import { render, staticRenderFns } from "./DialogHomeOwnerResponsability.vue?vue&type=template&id=5bbb9cdc&scoped=true&"
import script from "./DialogHomeOwnerResponsability.vue?vue&type=script&lang=js&"
export * from "./DialogHomeOwnerResponsability.vue?vue&type=script&lang=js&"
import style0 from "./DialogHomeOwnerResponsability.vue?vue&type=style&index=0&id=5bbb9cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb9cdc",
  null
  
)

export default component.exports